import { Link } from 'react-router-dom';
import { ContinuousRail } from '../commerce/ContinuousRail.jsx';
import { Rating } from '../commerce/Rating.jsx';
import { Section, SectionHeading } from '../layout/Section.jsx';

/**
 * The highest-rated products as a slow belt of cards.
 *
 * The belt itself — the doubled track, the pause on hover and focus, the static
 * row under reduced motion — lives in ContinuousRail. This file only decides
 * what a card looks like: a plain white square-cornered panel with a hairline,
 * the stars in gold, and the product named in small capitals underneath.
 */
export const HomeReviews = ({ products }) => {
  if (!products?.length) return null;

  return (
    <Section className="bg-cream">
      <SectionHeading
        eyebrow="In their words"
        title="What buyers rate highest"
        description="Every review is read before it appears, and the critical ones stay up."
      />
      {/* No edge fade: the mask dissolves to transparent, which reads as a
          smudge over the cream ground rather than a soft edge. */}
      <ContinuousRail
        items={products.slice(0, 8)}
        itemKey={(product) => product._id}
        speed={54}
        fade={false}
        itemClassName="w-[18rem] sm:w-[21rem]"
        renderItem={(product) => (
          <Link
            to={`/product/${product.slug}#reviews`}
            className="flex h-full flex-col border border-mist bg-surface p-6 transition-colors hover:border-brand focus-visible:outline-2 focus-visible:-outline-offset-2 focus-visible:outline-brand"
          >
            <Rating value={product.ratingAvg} count={product.ratingCount} size="lg" />
            <p className="mt-3 line-clamp-4 text-xs leading-relaxed text-ink">{product.shortDescription}</p>
            <p className="mt-auto pt-4 text-2xs font-medium tracking-[0.1em] text-brand uppercase">
              {product.title}
            </p>
          </Link>
        )}
      />
    </Section>
  );
};

export default HomeReviews;
